function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useRef } from 'react';
import CalendarHeader from './CalendarHeader.react';
import CalendarMonth from './CalendarMonth.react';
var getWeekDays = function getWeekDays(firstDayOfWeek) {
  switch (firstDayOfWeek) {
    case 'Sun':
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    case 'Mon':
      return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    default:
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }
};

// https://demo.improvely.com/reports/webshop/ads?imt=1&utm_campaign=Date+Range+Picker&utm_source=Site+Ads&utm_medium=Banner&utm_content=Blog+Demo+Image
// TODO :: use context!!!
// TODO :: send prop allowEmptyDate that will let you apply without selected dates
var Calendar = function Calendar(_ref) {
  var _ref$id = _ref.id,
    pId = _ref$id === void 0 ? null : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    visible = _ref.visible,
    _ref$selectedStartDat = _ref.selectedStartDate,
    selectedStartDate = _ref$selectedStartDat === void 0 ? false : _ref$selectedStartDat,
    _ref$selectedEndDate = _ref.selectedEndDate,
    selectedEndDate = _ref$selectedEndDate === void 0 ? false : _ref$selectedEndDate,
    _ref$range = _ref.range,
    range = _ref$range === void 0 ? false : _ref$range,
    _ref$firstDayOfWeek = _ref.firstDayOfWeek,
    firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 'Sun' : _ref$firstDayOfWeek,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose,
    onSelectDate = _ref.onSelectDate,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton;
  var _useState = useState(pId || uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState({
      weekDays: getWeekDays(firstDayOfWeek),
      selectedMonth: !selectedStartDate || !moment(selectedStartDate).isValid() ? moment(new Date()).format('YYYY-MM') : moment(selectedStartDate).format('YYYY-MM'),
      hoverDate: false,
      localStartDate: selectedStartDate,
      localEndDate: selectedEndDate
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    _setState = _useState4[1];
  var stateRef = useRef(state);
  var setState = function setState(diff) {
    stateRef.current = _objectSpread(_objectSpread({}, stateRef.current), diff);
    _setState(stateRef.current);
  };
  var selectedMonth = state.selectedMonth,
    weekDays = state.weekDays,
    hoverDate = state.hoverDate,
    localStartDate = state.localStartDate,
    localEndDate = state.localEndDate;
  useEffect(function () {
    if (!visible) setState({
      hoverDate: false
    });else setState({
      localStartDate: moment(selectedStartDate).isValid() ? selectedStartDate : false,
      localEndDate: moment(selectedEndDate).isValid() ? selectedEndDate : false
    });
  }, [visible]);
  var handleSelectDay = function handleSelectDay(date) {
    if (!range) {
      onSelectDate({
        startDate: date
      });
      setState({
        localStartDate: date
      });
      if (onClose) onClose();
    } else {
      if (!localStartDate && !localEndDate) {
        setState({
          localStartDate: date
        });
      } else if (localStartDate && !localEndDate) {
        if (moment(date).isBefore(moment(localStartDate))) {
          setState({
            localStartDate: date,
            localEndDate: localStartDate
          });
        } else setState({
          localEndDate: date
        });
      } else if (localStartDate && localEndDate) {
        setState({
          localStartDate: date,
          localEndDate: false
        });
      }
    }
  };
  var nextMonth = moment(selectedMonth).add(1, 'months').format('YYYY-MM');
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "calendar ".concat(className),
    id: id,
    style: style
  }, /*#__PURE__*/React.createElement(CalendarHeader, {
    selectedMonth: selectedMonth,
    nextMonth: nextMonth,
    range: range,
    onChangeMonth: function onChangeMonth(selectedMonth) {
      return setState({
        selectedMonth: selectedMonth
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(range && 'calendar__months')
  }, /*#__PURE__*/React.createElement(CalendarMonth, {
    selectedMonth: selectedMonth,
    weekDays: weekDays,
    handleSelectDay: handleSelectDay,
    selectedStartDate: localStartDate,
    selectedEndDate: localEndDate,
    range: range,
    onMouseEnter: function onMouseEnter(date) {
      return setState({
        hoverDate: date
      });
    },
    onMouseLeave: function onMouseLeave(date) {
      if (hoverDate === date) setState({
        hoverDate: false
      });
    },
    hoverDate: hoverDate
  }), range && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(CalendarMonth, {
    selectedMonth: nextMonth,
    weekDays: weekDays,
    handleSelectDay: handleSelectDay,
    selectedStartDate: localStartDate,
    selectedEndDate: localEndDate,
    range: range,
    onMouseEnter: function onMouseEnter(date) {
      return setState({
        hoverDate: date
      });
    },
    onMouseLeave: function onMouseLeave(date) {
      if (hoverDate === date) setState({
        hoverDate: false
      });
    },
    hoverDate: hoverDate
  }))), range && /*#__PURE__*/React.createElement("div", {
    className: "calendar__footer"
  }, showCloseButton && /*#__PURE__*/React.createElement("button", {
    type: "cancel",
    onClick: function onClick() {
      if (localStartDate || localEndDate) setState({
        localStartDate: false,
        localEndDate: false
      });else {
        if (onClose) onClose();
      }
    }
  }, localStartDate || localEndDate ? 'Clear' : 'Close'), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: !moment(localStartDate).isValid() || !moment(localEndDate).isValid(),
    onClick: function onClick() {
      onSelectDate({
        startDate: localStartDate,
        endDate: localEndDate
      });
    }
  }, "Apply")));
};
export default Calendar;